export default __webpack_public_path__ + "static/media/Jeff Rosen.850d5afe.jpg";